module.exports = __webpack_public_path__ + "img/sgntr.c15f5055.png";